// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @13.12.2018 15:04:21
import { RbacPermission_abstract } from './../../abstract/SagaBase/RBAC/RbacPermission_abstract';
export class RbacPermission extends RbacPermission_abstract {}
